import React from 'react';
import { useLocation } from 'react-router-dom';
import Impressao from './components/Impressao';

interface LocationState {
  orcamentoVersaoId: number;
  tipoProduto: string;
}

const ConfiguracaoImpressao: React.FC = () => {
  const location = useLocation<LocationState>();
  const orcamentoVersaoId = location.state?.orcamentoVersaoId ?? null;

  // 'Irrigacao' : 'Fotovoltaica'
  const tipoProduto = location.state?.tipoProduto ?? '';

  return (
    <>
      <Impressao
        orcamentoVersaoId={orcamentoVersaoId}
        tipoProduto={tipoProduto}
        isPrevia={false}
      />
    </>
  );
};

export default ConfiguracaoImpressao;
